module.exports = __webpack_public_path__ + "img/loader-2.63c94f02.gif";